module.exports = __webpack_public_path__ + "images/nav_designer.png";